<template>
    <div>  

        <!-- //-----------------payment------------- -->
        <v-dialog
            v-model="dialog_payment_summary"
            scrollable   
            :persistent="false" :overlay="false"
            max-width="1250px"
            transition="dialog-transition" >
            <v-card rounded="lg"  v-if="dialog_payment_summary" > 
                <v-toolbar style="--px:-18px;" dark class="mbs-pull-x- primary  px-4" 
                    flat color="transparent" >
                    <v-layout align-center> 
                        <div class="font-weight-bold    text--darken-2 ml-">
                            <span v-if="selected_card_option=='load_money'">Card Load Money</span>
                            <span v-if="selected_card_option=='pay'">Card Payment</span>
                            <span v-else>Payment</span>
                        </div> 
                        <v-spacer></v-spacer>
                        <!-- <v-btn outlined>Pay</v-btn> -->
                        <v-btn icon @click="dialog_payment_summary=false">
                            <v-icon  >close</v-icon>
                        </v-btn>
                    </v-layout> 
                </v-toolbar>   
                <v-layout row wrap  class="ma-0 b1">
                    <v-flex xs12 sm12 md5 v-if="!vs.smAndDown" class="">   
                        <mbs-sale-payments-summary 
                            class="mx-4 mt-4"
                            :height="vsh-215"
                            :outlined="true"
                            :till="till"
                            :item_order="item_order"
                            :selected_items="selected_items"
                            :TotalPrice="TotalPrice"
                            :CalculatedVAT="CalculatedVAT"
                            :CALCULATE_PRICE="CALCULATE_PRICE"
                            :PriceExcludeVAT="PriceExcludeVAT"
                            :TotalDiscountedPrice="TotalDiscountedPrice"
                            :CompanySettings="CompanySettings"
                            :vsh_payment_sam_table="vsh_payment_sam_table"
                            :input_exports="input_exports"
                        /> 
                    </v-flex>
                    <v-flex xs12 sm12 md7 class="py-0 ma-0">
                        <v-card height="100%" class="pt-5"  rounded="sm" flat> 
                            <v-card rounded="sm" class="primary mx-4 px-5 py-2" dark>
                                <v-layout  align-center>
                                    
                                    <div v-if="!vs.xs" class="font-weight-bold not-f5 mr-4 ">TOTAL TO PAY</div>
                                    <div class="font-weight-bold not-f9">
                                        {{selected_card_option=='load_money'?MBS.actions.money(pay_order.card_load_amount): MBS.actions.money(TotalDiscountedPrice)}}
                                    </div>
                                </v-layout> 
                            </v-card>
                            <v-card-text>
                                <form @submit.prevent="VERIFY_SUBMIT_ORDER(pay_order,'on_account')">
                                    <v-checkbox class="ml-2 mt-0"
                                        v-model="input_exports"
                                        label="Exports"
                                        color="primary" 
                                        hide-details
                                        ></v-checkbox>
                                    <v-layout align-center justify-center class="pb-5 pt-2"> 
                                        <v-btn 
                                            @click="ON_PAY()"
                                            :loading="inputLoading"
                                            color="secondary" class="mr-3" 
                                            :min-width="vs.smAndDown?'180':'200'" :height="vs.smAndDown?'45':'50'" 
                                            :large="!vs.smAndDown"  
                                            :small="vs.smAndDown"  
                                            >
                                            <div class="not-f6">Pay</div>
                                        </v-btn> 
                                        <v-btn @click="VERIFY_SUBMIT_ORDER(pay_order,'card_payment')"   
                                            v-if="selected_card_option=='pay'"    color="secondary" class="my-5" 
                                                min-width="200" height="50"  > 
                                            <v-icon>mdi-credit-card-outline</v-icon>
                                            <span class="pl-2">Pay</span>
                                        </v-btn>   
                                        <v-menu v-if="MBS.actions.SIZE(PaymentMethodsData)>0"
                                            v-model="menuPaymentOptions" 
                                            :close-on-content-click="false" 
                                            offset-y  offset-overflow
                                            :nudge-width="90" rounded="xl"
                                            >
                                            <template v-slot:activator="{ on }">  
                                                <v-btn v-on="on"  
                                                    :loading="inputLoading"
                                                    color="primary" class="mr-1" 
                                                    :min-width="vs.smAndDown?'180':'200'" :height="vs.smAndDown?'45':'50'" 
                                                    :large="!vs.smAndDown"  
                                                    :small="vs.smAndDown"  
                                                    >
                                                    <div class="not-f6">Pay Options</div> 
                                                    <v-icon class="ml-1 mr-1">arrow_drop_down</v-icon>
                                                </v-btn>
                                            </template> 
            
                                            <v-card>
                                                <v-card-title primary-title class="secondary white--text"  >
                                                    Select Payment Option
                                                </v-card-title>
                                                <v-list>
                                                    <v-list-item v-for="(payment_option, index) in [{code:'cash',key:'cash',name:'CASH'},
                                                            ...PaymentMethodsData
                                                        ]" :key="index" @click="SELECT_PAYMENT_OPTION(payment_option)">
                                                        {{payment_option.name}}
                                                    </v-list-item>
                                                </v-list>
                                            </v-card>
                                        </v-menu>   
                                        
                                    </v-layout>
                                    
                                    <v-card outlined :height="vs.xs?vsh-670:vsh-495" class=" mbs-scroll-y"> 
                                        <v-card-text> 
                                            <mbs-input-fields  
                                                v-model="input"
                                                :field_items="DATA.FIELDS.sale_on_account"
                                                :select_items="DataSource" 
                                                :disabled_fields="DisabledOnAccountFields" 
                                                px="1" py="1"
                                                /> 
                                        </v-card-text>
                                    </v-card>
                                    <v-layout row wrap class="mt-5">
                                        <v-col v-if="!vs.xs"  cols="12" sm="4" >
                                            <v-btn disabled large color="secondary darken-2" width="100%">Layby</v-btn>
                                        </v-col>
                                        <v-col v-if="!vs.xs"  cols="12" sm="4" class="px-0">
                                            <v-btn :disabled="item_order?.order_type == 'quotation'"  type="submit" @click="created_document_type='quotation'" large color="secondary darken-4" width="100%">Create Quotation</v-btn>
                                        </v-col>
                                        <v-col cols="12" sm="4" >
                                            <v-btn type="submit" @click="created_document_type='invoice'"  large color="secondary darken-2" width="100%">On Account (Invoice)</v-btn>
                                        </v-col>
                                    </v-layout> 
                                </form>
                            </v-card-text> 
                        </v-card> 
                    </v-flex> 
                </v-layout>
            </v-card> 
        </v-dialog>   
    </div>
</template> 
<script> 

    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex"  
    const PAGE_NAME = "SALE-ACTIONS"

    export default {
        props:[
            "value",'height',"click_mode","selected_items","item_order",'pay_order',"till",
            "selected_card","selected_card_option",
            "vsh_payment_sam_table","TotalPrice","TotalDiscount","TotalDiscountedPrice",
            "CalculatedVAT","PriceExcludeVAT","CALCULATE_PRICE","PaymentMethodsData",
            "DisabledOnAccountFields","DataSource",
        ],
        data(){
            return{
                show:false,   
                dialog_payment_summary:false,    
                input:this.value, 
                input_exports:false,  
                inputLoading:false, 
                menuPaymentOptions:false,   
                DATA:DATA,   
                 
            }
        },
        created(){ 
            try { 
                this.MBS.events.$on('ON_PAYMENT_SUMMARY', this.ON_PAYMENT_SUMMARY); 
               
                
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){  

        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint  
                return vs
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'],
                K_CONNECTOR: state=> state.items['K_CONNECTOR'],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],

                
            }), 

             
        },
        methods:{ 
            ITEM_ACTION(action,item,option){
                this.$emit("on_item_action",action,item,option)
            },
            ADD_ITEM(item_key, item_code){
                this.$emit("on_add_item",item_key, item_code)
            },
            ON_PAYMENT_SUMMARY(payload){
                console.log(payload,'///////////////');
                
                if (payload?.show!=null&&payload?.show!=undefined) {
                    this.dialog_payment_summary = payload.show
                }else{ 
                    this.dialog_payment_summary =! this.dialog_payment_summary
                }
            },
            ON_PAYMENT_OPTIONS(value){
                console.log("CHECK!....................................."); 
            },
            ON_PAY(){
                try {    
                    this.$emit("ON_PAY")
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_PAY',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            SELECT_PAYMENT_OPTION(payment_option){
                try {    
                    this.$emit("SELECT_PAYMENT_OPTION",payment_option)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SELECT_PAYMENT_OPTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            VERIFY_SUBMIT_ORDER(order,account){
                try {    
                    this.$emit("VERIFY_SUBMIT_ORDER",order,account)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'VERIFY_SUBMIT_ORDER',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            

            //---------------[MAIN FUNCTIONS]------------   
             

        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('ON_PAYMENT_SUMMARY', this.ON_PAYMENT_SUMMARY);  
                this.MBS.events.$off('MBS_KEYBOARD', this.MBS_KEYBOARD);      
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{   
            input(value){ 
                this.$emit("input",{
                    ...value,
                    // input_exports:this.input_exports
                })
            },
            dialog_payment_summary(value){
                console.log({
                    dia:value , 
                    input:this.input,
                    value:this.value},"dialog_payment_summary.....");
                this.input = this.value
            },
            input_exports(value){
                this.$emit("input",{
                    ...this.input,
                    input_exports: value,
                })
                this.$emit("input_export",value)
            },
            selected_items(value){
                 
            },
            CompanySettings(value){
                if (value) {    
                }
            }, 
            selected_departments(value){
                this.ON_UPDATE_DEPARTMENT(value)
                if (value) {   
                    this.INITIALIZE_ITEMS_CATEGORIES() 
                }
            },  
        } 

    }
</script>
<style>
    .selected {
        background-color: #a8dadc;
    }
    .checked {
        background-color: #dadada;
    }
    
</style> 